<template>
  <!-- 功能配置 -->
  <section class="viewContainer">
    <div class="main_container">
      <div class="twoflex">
        <p>
          <b style="font-size: 20px;">钱包余额：
            <span style="color: #F56C6C;">
              {{ accumulate.balance }}
            </span> 元
          </b>
          <b style="font-size: 20px;margin-left: 15px;">冻结金额：
            <span style="color: #F56C6C;">
              {{ accumulate.freezeamount }}
            </span> 元
          </b>

        <div v-show="iscityadmin == 0" style="margin-left: 30px;margin-top: 7px;">
          <el-button type="primary" @click="handlecztx(1)">充值</el-button>
        </div>
        </p>
        <!-- <p style="color: #ccc;">温馨提示：账户余额等数据会根据实际交易情况实时产生变动。</p> -->
      </div>
      <!-- <div class="fourflex">
        <div>累计充值：<b>{{ accumulate.rechargeamount ? accumulate.rechargeamount : 0 }}</b> 元</div>
        <div>累计使用：<b>{{ accumulate.usedamount ? accumulate.usedamount : 0 }}</b> 元</div>
        <div>累计提现：<b>{{ accumulate.withdrawamount ? accumulate.withdrawamount : 0 }}</b> 元</div>
        <div :class="accumulate.waitamount ? '' : 'divhide'">
          待入账金额：<b>{{ accumulate.waitamount }}</b> 元</div>
        <div :class="accumulate.recordedprice ? '' : 'divhide'">
          提现待打款：<b style="color: #409EFF;">{{ accumulate.recordedprice }}</b> 元</div>
        <div v-show="iscityadmin == 0">
          <el-button type="primary" @click="handlecztx(1)">充值</el-button>
          <el-button type="danger" @click="handlecztx(2)">提现</el-button>
        </div>
      </div> -->
    </div>
    <div class="main_container">
      <p style="margin-left: 15px;"><b>功能配置列表</b></p>
      <div class="table_container">
        <el-table :data="onelist" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope"> <span>{{ scope.$index + 1 }}</span> </template>
          </el-table-column>
          <el-table-column prop="name" label="功能名称" align="center" />
          <!--  fixed="right" -->
          <el-table-column label="操作" width="200" align="center">
            <template scope="scope">
              <el-switch v-model="scope.row.isOpen" active-text="开" inactive-text="关" active-color="#138cdd"
                inactive-color="#999999" @change="handleSwitchChange(scope.row, $event)" />
            </template>
          </el-table-column>
          <el-table-column prop="describe" label="说明" align="center" />
        </el-table>
        <!-- <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-size="10" :total="total" style="float:right;margin:10px 0;" /> -->
      </div>
    </div>

    <!-- 充值&提现-弹框 -->
    <el-dialog :title="cztxtitle" :visible.sync="dialogcztx" :center="true" width="35%" append-to-body>
      <el-form style="padding-bottom: 20px;">
        <template v-if="cztxtitle == '账户充值'">
          <el-form-item label="账户充值：" :style="sjdzje ? 'margin-bottom: 0;' : ''">
            <el-input v-model="zhcz" placeholder="请输入要充值的金额" maxlength="8" style="width:70%;"
              onkeyup="this.value=this.value.replace(/\D|^0/g,'')">
              <i slot="prefix" style="margin-left: 10px;">¥</i>
            </el-input>
            <br>
            <span style="color: #bbb;margin-left: 80px;" v-show="sjdzje">实际到账金额: {{ sjdzje.toFixed(2) }}</span>
          </el-form-item>
          <el-form-item label="通知手机号：">
            <el-input v-model="noticePhone" placeholder="请输入手机号" style="width:70%;" maxlength="11"
              onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" />
          </el-form-item>
          <ul style="line-height: 25px;color: #bbb;">
            <li>温馨提示：</li>
            <li>1.当前操作仅支持微信扫码支付；</li>
            <li>2.实际到账金额=充值金额-充值金额*6‰，其中6‰为微信收取的手续费；</li>
            <li>3.通知手机号是为了金额到账后接收短信提醒；</li>
            <li>4.充值金额将在3-7个工作日入账，充值金额一年内允许提现，提现失效的余额在系统中可以继续使用。</li>
          </ul>
        </template>
        <template v-else>
          <!-- <el-form-item label="提现账号：" :style="unregistered?'margin-bottom: 0;':''">
          <el-input v-model="tixianzh" placeholder="请输入收款人手机号（手机号已注册'甄惠装'小程序'）" maxlength="11"
          @input="handletx" style="width:70%">
          <i slot="suffix" class="el-input__icon el-icon-success" style="color: #5cbb7a;" v-show="registered"/>
          <i slot="suffix" class="el-input__icon el-icon-error" style="color: #F56C6C;" v-show="unregistered"/>
          </el-input>
          <div style="color: #F56C6C;margin-left: 80px;" v-show="unregistered">手机号码未注册“甄惠装”小程序</div>
        </el-form-item>
        <el-form-item label="小程序码：" v-show="registered==false">
          <img src="../../assets/img/xcxm.jpg" style="width: 100px;"/>
        </el-form-item> -->
          <el-form-item label="提现金额：">
            <el-input v-model="zhtx" placeholder="请输入要提现的金额" style="width:70%;"
              oninput="value=value.replace(/[^\d^\.]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
              <!-- onkeyup="this.value=this.value.replace(/\D|^0/g,'')" -->
              <i slot="prefix" style="margin-left: 10px;">¥</i>
            </el-input>
            <br>
            <span style="color: #bbb;margin-left: 80px;">可提现金额: {{ accumulate.can_withdraw_price }}</span>
          </el-form-item>
          <ul style="line-height: 25px;color: #bbb;">
            <li>温馨提示：</li>
            <li>1.提现成功后会发送短信通知；</li>
            <li>2.可提现金额=系统将在提现后3-7个工作日内进行打款，节假日顺延</li>
            <li>3.可提现金额=一年内充值且未消耗的金额总和；</li>
            <li>3.提现时系统会根据充值顺序依次原路返还，短信通知人为充值时输入的手机号。</li>
          </ul>
        </template>
      </el-form>
      <div style="text-align:center">
        <el-button @click="dialogcztx = false">取消</el-button>
        <el-button type="danger" @click="fixFh(1)">充值</el-button>
      </div>
    </el-dialog>

    <el-dialog title="重要提示" :center="true" class="add_order_cancle" width="30%" :visible.sync="isToExamine">
      <el-form>
        <el-form-item>
          <div style="text-align: center;" v-show="isToExaminMsg == 1">开通此功能需缴纳{{onePrice
            }}元元保证金，因拨打电话导致号码被投诉，核实后会用此金额抵扣</div>
          <div style="text-align: center;" v-show="isToExaminMsg == 2">关闭将会退回保证金{{ onePrice }}元</div>
        </el-form-item>
      </el-form>
      <div style="padding-left:0;text-align:center">
        <el-button @click="isToExamine=false">取消</el-button>
        <el-button type="danger" @click="confirmSwitch" :disabled="isSubmitting">确定</el-button>
      </div>
    </el-dialog>


    <!-- 抽屉详情 size="50%" -->
    <el-drawer :visible.sync="detailsDialog">
      <template v-slot:title>
        <span style="font-size: 18px;font-weight: bolder;color: #333;">交易详情</span>
      </template>
      <div style="width: 90%; margin: 0 auto;border-bottom: 1px solid #eee;padding: 10px 0 20px 0;">
        <!-- <b>任务信息</b> -->
        <p><span>创建时间：</span> <span>{{ formDetails.paytime }}</span></p>
        <p><span>交易对象：</span> <span>{{ formDetails.trademodename }}</span></p>
        <p><span v-if="this.tradetype == 1">交易方式：</span> <span v-else>支付方式：</span>
          <span>{{ formDetails.paymodename }}</span>
        </p>
        <p v-show="formDetails.isrefund == 1"><span>退款方式：</span> <span>{{ formDetails.paymodename }}</span></p>
        <p><span>交易金额：</span> <span>{{ formDetails.price }} 元</span></p>
        <p><span>交易状态：</span>
          <template v-if="formDetails.refundtradecode != ''">
            <span v-show="formDetails.isrefund == 1">退款成功</span>
            <span v-show="formDetails.isrefund == 0">全额退款</span>
          </template>
          <template v-else>
            <span>交易成功</span>
          </template>
        </p>
        <p><span>交易明细：</span> <span>{{ formDetails.remark }}</span></p>
        <p><span>交易单号：</span> <span>{{ formDetails.tradecode }}</span></p>
        <p v-show="formDetails.refundtradecode"><span>关联记录：</span>
          <span style="color: #409EFF; cursor: pointer;" @click="gljl(formDetails.refundtradecode)">{{
            formDetails.refundtradecode }}</span>
        </p>
      </div>
    </el-drawer>
    <!-- 微信扫码支付 -->
    <el-dialog title="微信扫码支付" :visible.sync="wxsmzfVisible" width="20%" center @close="closeWxsmzf">
      <div style="width: 90%; margin: 0 auto; text-align: center;">
        <div><b style="font-size: 26px;">{{ wxsmzfJine }} 元</b></div>
        <!-- <div style="color: #ccc;">（含6‰手续费）</div> -->
        <img :src="wxSmzfImg" style="width: 200px;" />
      </div>
    </el-dialog>

    <!-- 初始化弹框 -->
    <el-dialog title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%" center>
      <el-form class="findform">
        <el-form-item label="店铺名称：" style="display:flex;">
          <el-select v-model="bbid" filterable placeholder="请选择店铺">
            <el-option v-for="item in options1" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="gonext()">确定</el-button>
      </div>
    </el-dialog>

  </section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity, postPlaceOrderNative, payment, depositgetinfo, switchgetinfo  } from '../../api/newOss';
import { vmtransactionrefund } from "../../api/comment";
import {
  vmaccountgetinfo, vmaccountgetlist, vmaccountgetdetail, vmaccountgetbalance, vmaccountisrecharge,
  vmaccountwithdraw, getpayee, setpayee
} from "../../api/shopWindow";
export default {
  name: 'functionconfig', // 功能配置
  mixins: [alertTrends],
  data() {
    return {
      isToExamine: false,

      dialogVisibleadd: false,
      bbid: '',  //店铺id
      options1: [],

      timer: null, // 轮询
      lxTime: 0, // 初始开始请求时间
      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码
      monitorid: '', // 充值单ID

      accumulate: {}, // 累计
      onelist: [
        { id: 1, name: '客源大厅', isOpen: false, describe: '', price: '' },
        { id: 2, name: '店铺电话', isOpen: false, describe: '', price: '' },
      ],
      pageIndex: 1, // 当前页
      total: 0, // 总条数

      dialogcztx: false, // 账户充值 & 余额提现
      cztxtitle: '账户充值', // 标题
      zhcz: '', // 账户充值
      noticePhone: '', // 通知手机号
      tixianzh: '', // 提现账号
      registered: false, // 已注册
      unregistered: false, // 未注册
      zhtx: '', // 余额提现
      residuebalance: '', // 当前余额
      limit: '', // 当日最大可提现金额 单位：元

      detailsDialog: false, // 抽屉详情
      tradetype: '',
      formDetails: {}, // 任务信息

      iscityadmin: localStorage.iscityadmin, // 是否是城市管理员(城市分公司) 0=否 1=是

      configData: null, // 存储从后端获取的微信配置信息
      currentRow: null, // 保存当前操作的行数据

      getinfo: null,
      getinfoTwo: null,
      isToExaminMsg: null,  //用于判断提示框
      onePrice: '', //客源大厅保证金价格
      isSubmitting: false // 防重复点击开关

    };
  },
  computed: {
    sjdzje() {
      let thiszhcz = this.zhcz * 0.994;
      return (Math.floor(thiszhcz * 100) / 100);
    },
  },
  methods: {
    // 开关
    handleSwitchChange(row, value) {
      // value为开关变化后的状态（true/false）
      this.onePrice = row.price;
      this.currentRow = row;
      this.prevState = !value; // 记录之前的状态
      let recordid = null;
      let attach = null;

      // 如果要打开开关（value为true）
      if (value) {
        this.isToExaminMsg = 1;
        // 暂时恢复为关闭状态，等待确认
        row.isOpen = false;
        this.$swal({
          type: "warning",
          text: `开通此功能需缴纳${row.price}元元保证金，因拨打电话导致号码被投诉，核实后会用此金额抵扣`,
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then((res) => {
          attach = row.id == 1 ? "virtualnumberdeposit" : "precisioncustomer";
          if (res.value) {
            this.confirmSwitch(0, attach, row.id);
          }
        }).catch(() => {
          return;
        });

      } else {
        // 关闭开关，直接执行
        row.isOpen = true;
        this.isToExaminMsg = 2;
        this.$swal({
          type: "warning",
          text: `关闭将会退回保证金${row.price}元`,
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then((res) => {
          if (res.value) {
            recordid = row.id == 1 ? this.getinfo.recordid : this.getinfoTwo.recordid;
            attach = row.id == 1 ? "virtualnumberdeposit" : "precisioncustomer";
            this.confirmSwitch(recordid, attach, row.id);
          }
        }).catch(() => {
          return;
        });
      }
    },

    // 客源大厅初始化配置
    depositgetinfofun() {
      depositgetinfo('', this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.getinfo = data.resultObj;
          this.onelist[0].isOpen = true;
          this.onelist[0].price = data.resultObj.price;
          this.onelist[0].describe = `已缴纳保证金${data.resultObj.price}元`;
        } else {
          this.getinfo = null;
          this.onelist[0].isOpen = false;
          this.onelist[0].price = data.resultObj;
          this.onelist[0].describe = `需缴纳保证金${data.resultObj}元`;
        }
      });

      switchgetinfo('', this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.getinfoTwo = data.resultObj;
          this.onelist[1].isOpen = true;
          this.onelist[1].price = data.resultObj.price;
          this.onelist[1].describe = `已缴纳保证金${data.resultObj.price}元`;
        } else {
          this.getinfoTwo = null;
          this.onelist[1].isOpen = false;
          this.onelist[1].price = data.resultObj;
          this.onelist[1].describe = `需缴纳保证金${data.resultObj}元`;
        }
      });
    },
    confirmSwitch(recordid, attach, state) {
      if (this.isSubmitting) return;
      // 开始提交，锁定状态
      this.isSubmitting = true;

      if (this.currentRow) {
        if (this.isToExaminMsg==1){   //支付保证金
          var obj = {
            attach: attach,
            price: 0, // 支付金额 单位：元 （店铺分享赚钱必传）
            operatorid: localStorage.Id, // 操作人
            isconfirm: 1, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
          };
          payment(obj, 3, this.bbid).then(data => {
            this.isToExamine = false;
            if (data.resultCode == 1) {
              this.zysj = data.resultObj; // 返回金额 - 待确认支付：返回待支付金额 单位：元 确认支付：>0表示成功
              if (this.zysj > 0) {
                this.depositgetinfofun();
                this.getthree();

              } else if (this.zysj == 0) {
                this.showAlert('余额不足,请先充值');
              }
              setTimeout(() => {
                this.isSubmitting = false;
              }, 1000);
            } else {
              this.showAlert(data.resultMsg);
              this.isSubmitting = false; // 立即解锁
            }
            console.log(data, '???11')
          })
          .catch(err => {
            // 捕获异步错误，避免状态一直锁定
            console.log(err, data,'???22')
            this.showAlert('操作失败，请重试');
            this.isSubmitting = false;
          })
        } else {  // 退回保证金
          var obj = {
            attach: `${attach},${this.bbid},${recordid}`,
          };
          vmtransactionrefund(obj).then(data => {
            this.isToExamine = false;
            if (data.resultCode == 1) {
              if (state == 1) {
                this.onelist[0].isOpen = false;
                this.onelist[0].describe = `需缴纳保证金${this.onelist[0].price}元`;
              } else {
                this.onelist[1].isOpen = false;
                this.onelist[1].describe = `需缴纳保证金${this.onelist[1].price}元`;
              }
              this.getthree();
            } else {
              this.showAlert(data.resultMsg);
            }
            setTimeout(() => {
              this.isSubmitting = false;
            }, 1000);
          })
          .catch(err => {
            // 捕获异步错误，避免状态一直锁定
            this.showAlert('操作失败，请重试');
            this.isSubmitting = false;
          })
        }
      } else {
        this.isToExamine = false;
        this.currentRow = null;
        // 非提交分支也需要解锁
        this.isSubmitting = false;
      }
    },
    
    getthree() {
      vmaccountgetinfo('', 3, this.bbid).then(data => {
        this.accumulate = data.resultObj; // 累计
      });
    },
    // 账单明细&充值记录&提现记录
    init() {
      let obj = {
        mode: this.zdmxczjltxjl == 6 ? '' : this.zdmxczjltxjl, // 交易方式0=全部 1=账户充值 2=余额提现 3=客户资源
        type: this.zdmxczjltxjl == 6 ? 4 : '',
        pageindex: this.pageIndex,
        pagesize: 10
      };
      vmaccountgetlist(obj, 3, this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.threelist = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        } else {
          this.threelist = [];
          this.total = 0;
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      // this.init();
    },
    // 查看
    chakancontent(row) {
      this.tradetype = row.tradetype; // 交易类型
      this.detailsDialog = true;
      vmaccountgetdetail('', 3, this.bbid, row.tradecode).then(data => {
        this.formDetails = data.resultObj; // 交易详情
      });
    },
    // 提现账号
    handletx() {
      if (this.tixianzh.length == 11) {
        this.setpayee(); // 设置
      } else {
        this.registered = false;
        this.unregistered = false;
      }
    },
    // 获取
    getpayee() {
      getpayee('', this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.tixianzh = data.resultObj; // 店铺收款人手机号
          this.registered = true;
          this.unregistered = false;
        } else {
          this.registered = false;
          this.unregistered = true;
        }
      });
    },
    // 设置
    setpayee() {
      let obj = {
        phone: this.tixianzh,
      }
      setpayee(obj, this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.registered = true;
          this.unregistered = false;
        } else {
          this.registered = false;
          this.unregistered = true;
        }
      });
    },
    // 充值提现
    handlecztx(type) {
      if (!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      this.dialogcztx = true;
      if (type == 1) {
        this.cztxtitle = '账户充值';
        this.zhcz = '';
        this.noticePhone = '';
      } else {
        this.cztxtitle = '余额提现';
        this.tixianzh = '';
        this.registered = false;
        this.unregistered = false;
        this.zhtx = '';
        this.getpayee(); // 先获取手机号
      }
    },
    // 充值&提现 - 确定操作按钮
    fixFh(type) {
      if (type == 1) { // 走充值逻辑
        if (this.zhcz == '') {
          this.showAlert('账户充值不能为空');
          return;
        }
        if (this.noticePhone == '') {
          this.showAlert('通知手机号不能为空');
          return;
        }
        let obj = {
          attach: 'vmrecharge,' + 3 + ',' + this.bbid + ',' + this.zhcz + ',' + 2 + ',' + localStorage.Id + ',' + this.noticePhone
        };
        postPlaceOrderNative(obj).then(data => {
          if (data.resultCode == 1) {
            this.dialogcztx = false;
            this.wxsmzfVisible = true;
            this.wxsmzfJine = data.resultObj.price; // 金额（单位0）
            this.monitorid = data.resultObj.monitorid; // 充值单ID
            this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片

            this.lxTime = new Date().getTime() // 获取触发轮询时的时间
            this.inquireData() // 调用轮询接口,开始进行轮询

          } else if (data.resultCode == 4) {
            this.showAlert('支付成功', 'success');
            this.getthree();
            this.pageIndex = 1;
            // this.init();
          }
        });
      }
    },
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
    // 轮询请求
    inquireData() {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.lxTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      vmaccountisrecharge('', this.monitorid).then(res => {
        if (res && res.resultCode === 1) {
          // resultObj 充值单状态 0=未支付 1=已支付
          if (res.resultObj === 1) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.dialogcztx = false;
            this.showAlert('支付成功', 'success');
            this.getthree();
            this.pageIndex = 1;
            // this.init();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 复选框
    handleSelectionChange(val) {
      this.goodIdarr = [];
      val.forEach(element => {
        this.goodIdarr.push(element.Id);
      });
    },
    // 关联记录
    gljl(row) {
      this.detailsDialog = true;
      vmaccountgetdetail('', 3, this.bbid, row).then(data => {
        this.formDetails = data.resultObj; // 交易详情
      });
    },
    // 商家联盟获取用户身份以及可查看的店铺
    tankuang() {
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if (this.bbid) {
              this.gonext();
            } else {
              if (data.resultObj.length > 1) {
                // this.bbid = data.resultObj[0].id; // 店铺id
                // this.gonext();
                this.dialogVisibleadd = true;
                this.options1 = data.resultObj;
              } else { // 默认选中第一个店铺不显示弹框
                this.dialogVisibleadd = false;
                this.bbid = data.resultObj[0].id; // 店铺id
                this.gonext();
              }
            }
          }
        }
      })
    },
    gonext() {
      console.log(this.bbid)
      if (this.bbid == "") {
        this.showAlert('请选择店铺名称');
        return false
      }
      this.getthree();
      this.depositgetinfofun();
      this.pageIndex = 1;
      // this.init();
      this.dialogVisibleadd = false;
    },
  },
  mounted() {
    this.bbid = this.$route.query.shopid; // 店铺id
    this.tankuang(); // 商家联盟获取用户身份以及可查看的店铺
    // this.loadWechatSDK(); // 加载微信 JS-SDK
  },
};
</script>

<style scoped>
.twoflex {
  display: flex;
  justify-content: flex-start;
  margin: 0 15px 0 20px;
}


/* 元素占位 */
.divhide {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// functionconfig.vue?46a5fb44